import Impferinnerung from '@/types/Impferinnerung';

export default class Impferinnerungsbrief extends Impferinnerung {
    public brief?: string | null;

    constructor(data?: Partial<Impferinnerungsbrief>) {
        super(data);
        Object.assign(this, data);
    }
}
